import { render } from "./Multiselect.vue?vue&type=template&id=0f4ce203"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"

import "./Multiselect.vue?vue&type=style&index=0&id=0f4ce203&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__